/* global window */
import { parse } from 'qs';

const useQuery = () => {
  const { search } = window.location;
  return parse(search, { ignoreQueryPrefix: true });
};

export default useQuery;
